import { useState } from 'react'

import initValue from './context/initValue'
import RMAContext from './context/RMAContext'
import TransactionRMAPageContent from './TransactionRMAPageContent/TransactionRMAPageContent'

const TransactionRMAPage = () => {
  const [rmaInfo, setRmaInfo] = useState(initValue)

  return (
    <RMAContext.Provider value={{ rmaInfo, setRmaInfo }}>
      <TransactionRMAPageContent />
    </RMAContext.Provider>
  )
}

export default TransactionRMAPage
